import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-politicas',
  templateUrl: './politicas.component.html',
  styleUrls: ['./politicas.component.scss'],
})
export class PoliticasComponent implements OnInit {

  constructor(public poper: PopoverController) { }

  ngOnInit() {}

  async cerraPopOver(){
    
    this.poper.dismiss({
      
    });
  
  }
}
